import React from 'react'
import { FontIcon } from 'react-md'

export default () => <FontIcon>edit</FontIcon>
